module.exports = __webpack_public_path__ + "static/lightbulb_icon-337f957a641df3f3565ea9c32cfcceaa.svg";